import React,{ useState, useEffect} from 'react';
import { createUseStyles } from 'react-jss';
import './Config.css';
import { Container,Row,Col,Button } from 'react-bootstrap';
import moment from "moment";
import "moment/locale/es";
moment.locale("mx");

const styles = createUseStyles( theme => ({
  box: {
    backgroundColor: 'transparent',
  },
  push: {
    cursor: 'pointer',
  },
  BoxConfig:{
    borderTop: `3px solid  ${theme.colorPrimary}`
  },
  ContentDescription:{
    backgroundColor: theme.colorPrimary
  }

}) )

export const Configuracion = () => {
  const classes = styles();

  // INFO GENERAL
  const [data,setData] = useState([]);
  // AGREGAR AGENTES / SUBAGENTES
  const [dataAgente,setDataAgente] = useState({
    nombre: '',
    clave: '',
    type: '1',
  });
  // AGREGAR DESCRIPCIONES
  const [dataDescripcion,setDataDescripcion] = useState('');
  // AGREGAR COMPAÑÍAS
  const [dataCompania,setDataCompania] = useState('');
  // AGREGAR RAMOS
  const [dataContrato,setDataContrato] = useState('');
  // AGREGAR SUB ELEMENTOS EN RAMOS
  const [dataSubContrato,setDataSubContrato] = useState({
    indexContratoSelected: -1,
    arr: [],
  });
  // AGREGAR SUB RAMOS
  const [dataValueSubContrato,setDataValueSubContrato] = useState('');
  
  useEffect(() => {
    const data = {
      opt: 'getConfig'
    }
    fetch('REST/controllers/mainController?opt=getConfig',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      setData(response);
    })
  
  },[])


  function setUpdateStatusDesc(index, data) {

    let { id_padre, status } = data.descripciones[index]
    status = (status === 1 ? 0 : 1)
    data.descripciones[index].status = 2
    const newData = {...data}
    setData(newData)

    const post = {
      id: id_padre,
      statusNuevo: status,
    }
    fetch('REST/controllers/mainController?opt=wiCambiaStatusContenedor',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      data.descripciones[index].status = status
      const newData1 = {...data}
      setData(newData1)
    })
      
  }

  function setUpdateFormAgente(opt, dataAgente, value) {

    if(opt === 1)
      dataAgente.nombre = value
    else if(opt === 2)
      dataAgente.clave = value
    else if(opt === 3)
      dataAgente.type = value

    if(opt === 4) {
      const { nombre, clave, type } = dataAgente

      if(nombre === '' || clave === '' || type === '') {
        alert('Por favor, rellena todos los campos solicitados.')
        return false
      }
      const post = {
        name: nombre,
        clave,
        tipo: type,
      }
      fetch('REST/controllers/mainController?opt=addNuevoAgenteSubagente',{
        method:'post', mode:'cors', body: JSON.stringify(post)
      })
      .then( response => response.json() )
      .then( response => {
        if(response === "ok") {
          data.agentes.push(dataAgente)
          const newData = { ...data, }
          setData(newData)

          const newDataAgente = { nombre: '', clave: '', type: '1', }
          setDataAgente(newDataAgente)
        }
      })

    } else {
      const newData = {...dataAgente}
      setDataAgente(newData)
    }
  }

  function changeStatusAgente(index, data) {
    // No eliminamos nada
    // data.agentes.splice(index, 1);
    const { id_clave, } = data.agentes[index]
    const status = data.agentes[index].status === 1 ? 0 : 1

    data.agentes[index].status = 2
    const newData = {...data}
    setData(newData)

    const post = {
      id: id_clave,
      statusNuevo: status,
    }
    fetch('REST/controllers/mainController?opt=cambiaStatusAgentesSubagentes',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      data.agentes[index].status = status
      const newData1 = {...data}
      setData(newData1)
    })

  }

  function setAddCompania(dataCompania, data) {
    if(dataCompania === '') {
      alert('Por favor, rellena todos los campos solicitados.')
        return false
    }

    const post = {
      input: dataCompania,
    }

    fetch('REST/controllers/mainController?opt=setValorCompanias',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      data.companias.push({
        id_compania: data.companias.length + 1,
        nombre: dataCompania
      })
      const newData1 = {...data}
      setData(newData1)
      setDataCompania('')
    })

  }

  function setAddDescripcion(dataDescripcion, data) {
    if(dataDescripcion === '') {
      alert('Por favor, rellena todos los campos solicitados.')
        return false
    }

    const post = {
      opt: 1,
      input: dataDescripcion,
      id_padre: '',
    }

    fetch('REST/controllers/mainController?opt=setValorConfiguracion',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      data.descripciones.push({
        id_padre: data.descripciones.length + 1,
        nombre: dataDescripcion,
        status: 1,
      })
      const newData1 = {...data}
      setData(newData1)
      setDataDescripcion('')
    })

  }

  function setAddContrato(dataContrato, data) {
    if(dataContrato === '') {
      alert('Por favor, rellena todos los campos solicitados.')
        return false
    }

    const post = {
      opt: 2,
      input: dataContrato,
      id_padre: '',
    }

    fetch('REST/controllers/mainController?opt=setValorConfiguracion',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      data.contratos.push({
        id_padre: data.contratos.length + 1,
        nombre: dataContrato,
        status: 1,
      })
      const newData1 = {...data}
      setData(newData1)
      setDataContrato('')
    })

  }

  function getListadoSubContratos(index, data) {
    setDataSubContrato({
      indexContratoSelected: index,
      arr: [],
    })

    const item = data.contratos[index]
    const { id_padre, } = item

    const post = {
      id_contrato: id_padre,
    }

    fetch('REST/controllers/mainController?opt=obtenListaTipoContratos',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      setDataSubContrato({
        indexContratoSelected: index,
        arr: response.hijo,
      })
    })

  }

  function setAddSubContrato(dataSubContrato, dataValueSubContrato, index, data) {
    if(dataValueSubContrato === '') {
      alert('Por favor, rellena todos los campos solicitados.')
        return false
    }

    const item = data.contratos[index]
    const { id_padre, } = item

    const post = {
      opt: 3,
      input: dataValueSubContrato,
      id_padre
    }

    fetch('REST/controllers/mainController?opt=setValorConfiguracion',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      dataSubContrato.arr.push({
        id_hijo: dataSubContrato.arr.length + 1,
        nombre: dataValueSubContrato,
        status: 1,
      })

      setDataSubContrato({...dataSubContrato})
      setDataValueSubContrato('')
    })

  }

  function changeStatusSubContrato(index, dataSubContrato) {
    const { id_hijo, } = dataSubContrato.arr[index]
    const status = dataSubContrato.arr[index].status === 1 ? 0 : 1

    dataSubContrato.arr[index].status = 2
    const newData = {...dataSubContrato}
    setDataSubContrato(newData)

    const post = {
      id: id_hijo,
      statusNuevo: status,
    }
    fetch('REST/controllers/mainController?opt=cambiaStatusSubContrato',{
      method:'post', mode:'cors', body: JSON.stringify(post)
    })
    .then( response => response.json() )
    .then( response => {
      dataSubContrato.arr[index].status = status
      const newData1 = {...dataSubContrato}
      setDataSubContrato(newData1)
    })

  }

  if(!data.descripciones)
    return null

  return(

    <div className="container-fluid">
      <div className="ws-main-container">
        <Container>
          
            <Row>
              <Col md={6} className={`mb-2 ${classes.box}`}>
                <div className={`ws-box-config pb-3 ${classes.BoxConfig}`}>
                  <h5>Información de usuarios</h5>

                  <div className={`cnt-bg ${classes.ContentDescription}`}>
                    <h6>Descripción</h6>
                    <p>En este apartado puedes especificar la información de tus clientes que deseas ver.</p>
                  </div>

                  <div className="cnt-options text-end mb-4">
                    <input className='form-control' style={{marginBottom:10}} type={'text'} onChange={ (ev) => setDataDescripcion(ev.target.value)} value={dataDescripcion} placeholder={'Ingresa un dato'} />
                    <Button className={'button ws-btn-primary'} onClick={() => { setAddDescripcion(dataDescripcion, data) }}>Guardar</Button>
                  </div>

                  {
                    data.descripciones.map((item,index) => (
                      <Row key={`key-desc-${index}`} className="config-item">
                        <Col style={{fontSize:'1rem',fontWeight:'400'}}>{item.nombre}</Col>
                        <Col className="text-end">
                          <p 
                          style={{fontFamily:'Roboto',fontSize:'.8rem',fontWeight:'400'}} 
                          className={`badge ${(item.status===1) ? 'bg-success' : (item.status===2) ? 'bg-primary' : 'bg-danger' } mb-0 ${classes.push}`} 
                          onClick={ () => {
                            setUpdateStatusDesc(index, data)
                          }}>{
                            item.status === 1
                            ? 'Activo'
                            : item.status === 2
                              ? 'Procesando...'
                            : 'Inactivo'
                          }</p>
                          
                        </Col>
                      </Row>
                    ))
                  }
                </div>
              </Col>
              <Col md={6} className={`mb-2 ${classes.box}`}>
                {
                  dataSubContrato.indexContratoSelected === -1 ? (
                    <>
                      <div className={`ws-box-config pb-3 ${classes.BoxConfig}`}>
                        <h5>Información de ramos</h5>

                        <div className={`cnt-bg ${classes.ContentDescription}`}>
                          <h6>Descripción</h6>
                          <p>Puedes agregar los ramos que maneja tu empresa y estos serán incluidos en la información de cada Cliente/Prospecto.</p>
                        </div>

                        <div className="cnt-options text-end mb-4">
                          <input className="form-control" style={{marginBottom:10}} type={'text'} onChange={ (ev) => setDataContrato(ev.target.value)} value={dataContrato} placeholder={'Ingresa un ramo'} />
                          <Button className={'button ws-btn-primary'} onClick={() => { setAddContrato(dataContrato, data) }}>Guardar</Button>
                        </div>
                       
                        {
                          data.contratos.map((item,index) => (
                            <Row key={`key-contratos-${index}`} className="config-item">
                              <Col style={{fontSize:'1rem',fontWeight:'400'}}>{item.nombre}</Col>
                              <Col className="text-end">
                                <p 
                                style={{fontFamily:'Roboto',fontSize:'.8rem',fontWeight:'400'}}
                                className={`mb-0 badge bg-success ${classes.push}`} 
                                onClick={() => {
                                  getListadoSubContratos(index, data)
                                }}>Mostrar</p>
                              </Col>
                            </Row>
                          ))
                        }
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="ws-box-config pb-3">
                        <p>
                          
                          <b 
                          className={`d-flex justify-content-between align-items-center ${classes.push}`} onClick={() => {
                            setDataSubContrato({
                              indexContratoSelected: -1,
                              arr: [],
                            })
                          }}>
                            <div className={`d-flex justify-content-start align-items-center ${classes.push}`}>
                              <i className="material-icons pointer IconFilter-0-2-14" id="ws_principal_filter">arrow_back</i>
                              Regresar
                            </div>
                            <div className={`d-flex justify-content-start align-items-center ${classes.push}`}>
                              <i className="material-icons pointer IconFilter-0-2-14" id="ws_principal_filter">close</i>
                            </div>
                          </b>
                        </p>
                        

                        <p style={{fontSize:'1.4rem'}}>Datos extras para el ramo: <b>{data.contratos[dataSubContrato.indexContratoSelected].nombre}</b></p>
                        
                        <div className="cnt-options text-end mb-4">
                          <input className="form-control" style={{marginBottom:10}} type={'text'} onChange={ (ev) => setDataValueSubContrato(ev.target.value)} value={dataValueSubContrato} placeholder={`Ingresa un valor en ${data.contratos[dataSubContrato.indexContratoSelected].nombre}`} />
                          <Button className={'button ws-btn-primary'} onClick={() => { setAddSubContrato(dataSubContrato, dataValueSubContrato, dataSubContrato.indexContratoSelected, data) }}>Guardar</Button>
                        </div>
                      
                        {
                          dataSubContrato.arr.map((item,index) => (
                            <Row key={`key-contratos-${index}`} className="config-item">
                              <Col style={{fontSize:'1rem',fontWeight:'400'}}>{item.nombre}</Col>
                              <Col className="text-end">
                                <p 
                                style={{fontFamily:'Roboto',fontSize:'.8rem',fontWeight:'400'}}
                                className={`badge ${(item.status===1) ? 'bg-success' : (item.status===2) ? 'bg-primary' : 'bg-danger' } mb-0 ${classes.push}`}  
                                onClick={ () => {
                                  changeStatusSubContrato(index, dataSubContrato)
                                }}>{
                                  item.status === 1
                                  ? 'Activo'
                                  : item.status === 2
                                    ? 'Procesando...'
                                  : 'Inactivo'
                                }</p>
                              </Col>
                            </Row>
                          ))
                        }
                      </div>
                    </>
                  )
                }
              </Col>
              <Col md={6} className={`mb-2 ${classes.box}`}>
                <div className={`ws-box-config pb-3 ${classes.BoxConfig}`}>
                  <h5>Compañías</h5>

                  <div className={`cnt-bg ${classes.ContentDescription}`}>
                    <h6>Descripción</h6>
                    <p>Puedes agregar nuevas compañías y serán mostradas cuando registres un nuevo contrato.</p>
                  </div>

                  <div className="cnt-options text-end mb-4">
                    <input className="form-control" style={{marginBottom:10}} type={'text'} onChange={ (ev) => setDataCompania(ev.target.value)} value={dataCompania} placeholder={'Ingresa una compañía'} />
                    <Button className={'button ws-btn-primary'} onClick={() => { setAddCompania(dataCompania, data) }}>Guardar</Button>
                  </div>

                  {
                    data.companias.map((item,index) => (
                      <Row key={`key-companias-${index}`} className="config-item">
                        <Col style={{fontSize:'1rem',fontWeight:'400'}}>{item.nombre}</Col>
                      </Row>
                    ))
                  }
                </div>
              </Col>
              <Col md={6} className={`mb-2 ${classes.box}`}>
                <div className={`ws-box-config pb-3 ${classes.BoxConfig}`}>
                  <h5>Agentes y subagentes</h5>

                  <div className={`cnt-bg ${classes.ContentDescription}`}>
                    <h6>Descripción</h6>
                    <p>Puedes agregar agentes y subagentes con su clave asociada.</p>
                  </div>

                  <div className="cnt-options text-end mb-4">
                    <input className="form-control" style={{marginBottom:10}} onChange={(ev) => { setUpdateFormAgente(1, dataAgente,ev.target.value) }} value={dataAgente.nombre} type={'text'} placeholder={'Ingresa un nombre'} />
                    <input className="form-control" style={{marginBottom:10}} onChange={(ev) => { setUpdateFormAgente(2, dataAgente,ev.target.value) }} value={dataAgente.clave} type={'text'} placeholder={'Ingresa una clave'} />
                    <select className="form-select" style={{marginBottom:10}} onChange={(ev) => { setUpdateFormAgente(3, dataAgente, ev.target.value) }}>
                      <option value={1}>Agente</option>
                      <option value={2}>Subagente</option>
                    </select>
                    <Button className={'button ws-btn-primary'} onClick={() => setUpdateFormAgente(4, dataAgente) } >Guardar</Button>
                  </div>

                  {
                    data.agentes.map((item,index) => (
                      <Row key={`key-agentes-${index}`} className="config-item">
                        <Col style={{fontSize:'1rem',fontWeight:'400'}}>{item.nombre}</Col>
                        <Col style={{fontSize:'1rem',fontWeight:'400'}}>{item.clave}</Col>
                        <Col className="text-end">
                          {
                          <p 
                          className={`badge ${(item.status===1) ? 'bg-success' : (item.status===2) ? 'bg-primary' : 'bg-danger' } mb-0 ${classes.push}`}  
                          onClick={ () => {
                            changeStatusAgente(index, data)
                          }}>{
                            item.status === 1
                            ? 'Activo'
                            : item.status === 2
                              ? 'Procesando...'
                            : 'Inactivo'
                          }</p>
                        }</Col>
                      </Row>
                    ))
                  }
                </div>
              </Col>

          </Row>

    </Container>
      </div>
    </div>
   
  ) 
}